module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8481/img/blobsRight.png"